import { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { CookieContext } from '@/common/contexts/CookieContext';
import { generateLinkToProductPage } from '@/common/functions/generateLinkToProductPage';
import { LanguageContext } from '@/common/contexts/LanguageContext';

const Wrapper = styled.footer`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 10px;
	padding: 10px;
	box-sizing: border-box;

	border-radius: 40px 40px 0px 0px;
	background: linear-gradient(91deg, #4f17aa 1.48%, #48068a 99.24%);
`;

const LinksWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
	padding: 10px;
	box-sizing: border-box;
`;

const CopyRight = styled.div`
	color: #ece5f2;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: center;

	@media (min-width: 600px) {
		text-align: left;
	}
`;

const LinkWrapper = styled(Link)`
	color: #ece5f2;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-decoration: none;
`;

const Footer = () => {
	const { manageCookie } = useContext(CookieContext);
	const { lang } = useContext(LanguageContext);
	const data = useLanguageData('footer');

	return (
		<Wrapper>
			<CopyRight>
				Copyright by DREAMAI TECHNOLOGIES {new Date().getFullYear()}
			</CopyRight>
			<LinksWrapper>
				<LinkWrapper
					to={generateLinkToProductPage(
						lang,
						data?.privacyUrl?.replace('/', ''),
					)}
					target='_blank'
				>
					{data?.privacy}
				</LinkWrapper>
				<LinkWrapper
					to={generateLinkToProductPage(lang, data?.rulesUrl?.replace('/', ''))}
					target='_blank'
				>
					{data?.rules}
				</LinkWrapper>
				<LinkWrapper onClick={() => manageCookie()}>{data?.cookie}</LinkWrapper>
				<LinkWrapper to={`mailto:${data?.mail}`}>{data?.mail}</LinkWrapper>
			</LinksWrapper>
		</Wrapper>
	);
};

export default Footer;
